module.exports = __webpack_public_path__ + "img/mountain.fd8c090.jpg";